import { ISelectOption } from "lobbie";
import { DEFAULT_GENDER_OPTION, GENDER_OPTIONS } from "src/constants/gender";
import { LEGAL_SEX_OPTIONS, SEX_ASSIGNED_AT_BIRTH_OPTIONS } from "src/constants/sex";

export interface IFormData {
    firstName: string;
    lastName: string;
    email: string;
    mobilePhone: string;
    gender: ISelectOption;
    sexAssignedAtBirth: ISelectOption;
    legalSex: ISelectOption;
    dateOfBirth: Date;
    practitionerId?: number;
    parent?: {
        firstName: string;
        lastName: string;
        email: string;
        mobilePhone: string;
        gender: ISelectOption;
        sexAssignedAtBirth: ISelectOption;
        legalSex: ISelectOption;
        dateOfBirth: Date;
        practitionerId?: number;
    };
    isCreatingParent?: boolean;
    parentId?: number;
}

export interface IField {
    title: string;
    name: string;
    type: "text" | "email" | "tel" | "date" | "select" | "checkbox";
    placeholder: string;
    defaultValue?: string;
    options?: ISelectOption[];
    defaultOption?: ISelectOption;
    allowMultipleSelections?: boolean;
}

export const FIELDS: IField[] = [
    {
        title: "First Name",
        name: "firstName",
        type: "text",
        placeholder: "First Name",
    },
    {
        title: "Last Name",
        name: "lastName",
        type: "text",
        placeholder: "Last Name",
    },
    {
        title: "Email",
        name: "email",
        type: "email",
        placeholder: "Email",
    },
    {
        title: "Mobile Phone",
        name: "mobilePhone",
        type: "tel",
        placeholder: "Mobile Phone",
    },
    // {
    //     title: "Email Opt-In",
    //     name: "receiveEmail",
    //     type: "checkbox",
    //     placeholder: "Opt-In to receiving emails?",
    // },
    // {
    //     title: "SMS Opt-In",
    //     name: "receiveSms",
    //     type: "checkbox",
    //     placeholder: "Opt-In to receiving SMS/text messages?",
    // },
    {
        title: "Date of Birth",
        name: "dateOfBirth",
        type: "date",
        placeholder: "Select a date of birth",
    },
    {
        title: "Gender",
        name: "gender",
        type: "select",
        placeholder: "Select a gender",
        options: GENDER_OPTIONS,
        defaultOption: DEFAULT_GENDER_OPTION,
        allowMultipleSelections: false,
    },
    {
        title: "Sex Assigned at Birth",
        name: "sexAssignedAtBirth",
        type: "select",
        placeholder: "Sex at birth...",
        options: SEX_ASSIGNED_AT_BIRTH_OPTIONS,
        allowMultipleSelections: false,
    },
    {
        title: "Legal Sex",
        name: "legalSex",
        type: "select",
        placeholder: "Legal sex...",
        options: LEGAL_SEX_OPTIONS,
        allowMultipleSelections: false,
    },
];
